import PropTypes from 'prop-types';
import React from 'react';
import {
  FieldContainer,
  Label,
  Required,
  StyledTextarea,
  HelperText,
} from './StyledComponents';

/**
 * Textarea - A reusable textarea component
 *
 * @param {string} label - Label text for the textarea
 * @param {boolean} required - Whether the field is required (shows red asterisk)
 * @param {string} value - The textarea value
 * @param {Function} onChange - Callback when value changes
 * @param {string} placeholder - Placeholder text
 * @param {number} rows - Number of visible text rows
 * @param {string} helperText - Helper/error text below the textarea
 * @param {boolean} error - Whether the textarea has an error state
 */
const Textarea = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  rows = 3,
  helperText,
  error = false,
  ...props
}) => {
  return (
    <FieldContainer>
      {label && (
        <Label>
          {label} {required && <Required>*</Required>}
        </Label>
      )}
      <StyledTextarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows={rows}
        error={error}
        {...props}
      />
      {helperText && <HelperText error={error}>{helperText}</HelperText>}
    </FieldContainer>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  helperText: PropTypes.string,
  error: PropTypes.bool,
};

export default Textarea;
